import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class GestionVehiculosService {
    escogidoBuscador: string;
    busquedaPor: number;
    // public escogidoAbc = new BehaviorSubject<any>({ id: 1, name: 'A', value: 'A', activado:  true  });
    carData: any;
    constructor() { }

    getBusquedaPor() {
        return this.busquedaPor;
    }
    setBusquedaPor(value) {
        // 0 por Input
        // 1 por Botonera
        this.busquedaPor = value;
    }

    getEscogidoBuscador() {
        return this.escogidoBuscador;
    }
    setEscogidoBuscador(value) {
        this.escogidoBuscador = value;
    }



    getGetByChassisWithCarCodes() {
        return this.carData;
    }
    setGetByChassisWithCarCodes(value) {
        this.carData = value;
    }


}
